interface ListItemProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: any
  children?: React.ReactNode
  disabled?: boolean
  checked?: boolean
  onChangeListItem?: () => void
  label?: string
}

export const ListItem = ({ children, disabled, checked, onChangeListItem, label, ...rest }: ListItemProps) => {
  const handleClick = () => {
    if (disabled) return
    onChangeListItem?.()
  }

  return (
    <div role="button" aria-pressed={checked} aria-disabled={disabled} onClick={handleClick} {...rest}>
      {children ?? <span>{label}</span>}
    </div>
  )
}
